import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-light-svg-icons'

import Box from '../../Box'
import Heading from '../../Heading'
import Text from '../../Text'

const Header = (props) => {
  const { callbacks: { closeModal }, titleSecondLine, title } = props

  return (
    <Box
      alignItems="flex-start"
      backgroundColor="white"
      borderBottom="1px solid"
      borderColor="lineColor"
      height="128px"
      justifyContent="space-between"
      paddingX="large"
      paddingY="xlarge"
      position="relative"
    >
      <Box flexDirection="column" lineHeight="1.3">
        <Heading size="large">{title || 'Heading'}</Heading>
        {titleSecondLine && <Heading size="large">{titleSecondLine}</Heading>}
      </Box>

      {closeModal && (
        <Text fontSize={['xxlarge', 'xlarge']} onClick={closeModal} padding="large" style={{ cursor: 'pointer' }}>
          <FontAwesomeIcon icon={faTimes} />
        </Text>
      )}
    </Box>
  )
}

Header.propTypes = {
  callbacks: PropTypes.shape({
    closeModal: PropTypes.func,
  }),
  titleSecondLine: PropTypes.string,
  title: PropTypes.string,
}

Header.defaultProps = {
  callbacks: {},
}

export default Header
